import Modal from 'react-bootstrap/Modal';
import { Button } from 'reactstrap';
import React, { Component } from 'react';
import EnvelopeDrawer from './EnvelopeDrawer.js';
import EnvelopeCurveDropdown from './EnvelopeCurveDropdown.js';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import Tone from 'tone';

const MAX_ZOOM = 1000;
const DEFAULT_GUIDE_LINE_TIME = 200; // 200ms

/**
 * Modal responsible for sequence-wide changes like
 * double setting the track length
 */
class EnvelopeModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            zoom: DEFAULT_GUIDE_LINE_TIME,
            selectedPoint: 'ATTACK'
        };

        this.onClickDone = this.onClickDone.bind(this);
        this.onClickCancel = this.onClickCancel.bind(this);
    }

    updateZoom(e) {
        this.setState({zoom: e.target.value});
    }

    onClickDone() {
        this.props.hide();
    }

    onClickCancel() {
        this.props.hide();
    }

    onEnvelopeUpdated() {
        this.setState(this.state);
    }

    setSelectedPoint(pt) {
        this.setState({selectedPoint: pt});
    }

    onUpdateEnvelopeCurve(curve) {
        this.setState(this.state);
    }

    render() {
        let envelope = this.props.envelope;
        let name = this.props.name ||
            this.props.envelopeType + " Envelope";
        return (
            <Modal dialogClassName="envelope-modal" show={this.props.show} onHide={this.onClickCancel}>
              <Modal.Header closeButton>
                <Modal.Title>{name}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <EnvelopeDrawer
                  onEnvelopeUpdated={() => this.onEnvelopeUpdated()}
                  envelopeType={this.props.envelopeType}
                  setSelectedPoint={(pt) => this.setSelectedPoint(pt)}
                  selectedPoint={this.state.selectedPoint}
                  showLevel={this.props.showLevel}
                  zoom={this.state.zoom}
                  envelope={this.props.envelope}/>
                <div className="envelope-parameters-container">
                <div>
                  <div>Zoom: {this.state.zoom} ms</div>
                  <ReactBootstrapSlider
                    value={this.state.zoom}
                    change={(e) => this.updateZoom(e)}
                    step={1}
                    max={MAX_ZOOM}
                    min={1}
                    orientation="horizontal"
                    reversed={false}
                    />
                </div>
                <div className="envelope-parameters">
                  <div>
                    <span className="envelope-parameter">Level:
                      <span className="envelope-value">{Math.round(envelope.level*100)/100.0}</span>
                    </span>
                    <span className="envelope-parameter">Attack:
                      <span className="envelope-value">{Math.round(envelope.attack*100)/100.0}</span>
                    </span>
                    <span className="envelope-parameter">Decay:
                      <span className="envelope-value">{Math.round(envelope.decay*100)/100.0}</span>
                    </span>
                  <span className="envelope-parameter">Sustain:
                    <span className="envelope-value">{Math.round(envelope.sustain*100)/100.0}</span>
                  </span>
                  <span className="envelope-parameter">Release:
                    <span className="envelope-value">{Math.round(envelope.release*100)/100.0}</span>
                  </span>
                  </div>
                  <div>
                    <EnvelopeCurveDropdown
                      onUpdateEnvelopeCurve={(x) => this.onUpdateEnvelopeCurve(x)}
                      selectedPoint={this.state.selectedPoint}
                      envelopeType={this.props.envelopeType}
                      envelope={this.props.envelope}/>
                  </div>
                </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={this.onClickDone}>
                  Done
                </Button>
                <Button variant="primary" onClick={this.onClickCancel}>
                  Cancel
                </Button>
              </Modal.Footer>
            </Modal>
        );
    }
}

export default EnvelopeModal;
